import React from 'react';
import { useUI } from '../contexts/UIContext';
import { useCategoriesContext } from '../contexts/CategoriesContext';

const ContextTester = () => {
    const { 
        size,
        isLoading: uiLoading,
        error: uiError,
        showToast
    } = useUI();

    const {
        categories,
        isLoading: categoriesLoading,
        error: categoriesError,
        getCategorySlug,
        getCategoryIdFromSlug,
        getCategoryNameById
    } = useCategoriesContext();

    // Test UI Context functions
    const testToast = () => {
        showToast('Test toast message', 'info');
        setTimeout(() => {
            showToast('Test error message', 'error', 2000);
        }, 2000);
        setTimeout(() => {
            showToast('Test success message', 'success', 2000);
        }, 4000);
    };

    // Test Categories Context functions
    const testCategoryFunctions = () => {
        if (categories.length > 0) {
            const firstCategory = categories[0];
            console.log('Category Slug Test:', {
                name: firstCategory.name,
                slug: getCategorySlug(firstCategory.name)
            });
            
            console.log('Category ID from Slug Test:', {
                slug: 'ai',
                id: getCategoryIdFromSlug('ai')
            });

            console.log('Category Name by ID Test:', {
                id: 9,
                name: getCategoryNameById(9)
            });
        }
    };

    return (
        <div style={{ 
            padding: '20px', 
            backgroundColor: '#1a1a1a', 
            color: 'white',
            fontFamily: 'monospace'
        }}>
            <h2>Context Tester</h2>
            
            <div style={{ marginBottom: '20px' }}>
                <h3>UI Context</h3>
                <p>Current Size: {size}</p>
                <p>UI Loading: {uiLoading.toString()}</p>
                <p>UI Error: {uiError || 'None'}</p>
                <button 
                    onClick={testToast}
                    style={{
                        padding: '8px 16px',
                        margin: '8px 0',
                        backgroundColor: '#4a4a4a',
                        border: 'none',
                        borderRadius: '4px',
                        color: 'white',
                        cursor: 'pointer'
                    }}
                >
                    Test Toast Messages
                </button>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h3>Categories Context</h3>
                <p>Categories Loading: {categoriesLoading.toString()}</p>
                <p>Categories Error: {categoriesError || 'None'}</p>
                <p>Categories Count: {categories.length}</p>
                <div style={{ 
                    maxHeight: '200px', 
                    overflow: 'auto', 
                    backgroundColor: '#2a2a2a',
                    padding: '8px',
                    borderRadius: '4px'
                }}>
                    <pre>
                        {JSON.stringify(categories, null, 2)}
                    </pre>
                </div>
                <button 
                    onClick={testCategoryFunctions}
                    style={{
                        padding: '8px 16px',
                        margin: '8px 0',
                        backgroundColor: '#4a4a4a',
                        border: 'none',
                        borderRadius: '4px',
                        color: 'white',
                        cursor: 'pointer'
                    }}
                >
                    Test Category Functions
                </button>
            </div>
        </div>
    );
};

export default ContextTester;